import * as React from "react";

export function StarReviewsIcon({width, height}: { width: number, height: number }) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.0625 13.2292L8.33333 11.2708L11.6042 13.25L10.7292 9.54167L13.6042 7.04167L9.8125 6.70833L8.33333 3.20833L6.85417 6.6875L3.0625 7.02083L5.9375 9.52083L5.0625 13.2292ZM3.1875 15.8333L4.54167 9.97917L0 6.04167L6 5.52083L8.33333 0L10.6667 5.52083L16.6667 6.04167L12.125 9.97917L13.4792 15.8333L8.33333 12.7292L3.1875 15.8333Z" fill="black" />
    </svg>
  );
}
